import { zSchema, schemes } from "@zeal/common";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { ICompanyUser, LEGAL_STRUCTURES } from "@zeal/common";

export const CompanyAddDepositAccountsRequestBodySchema = zSchema.object({
  company_id: schemes.companyID(),
  business_address: zSchema.string(),
  business_city: zSchema.string(),
  business_ein: zSchema.string(),
  business_name: zSchema.string(),
  business_phone: zSchema.string(),
  business_state: zSchema.string(),
  business_zip: schemes.zipCode(),
  legal_structure: zSchema.enum(LEGAL_STRUCTURES),
  owner_address: zSchema.string(),
  owner_city: zSchema.string(),
  owner_dob: zSchema.string(),
  owner_email: schemes.email(),
  owner_first_name: zSchema.string(),
  owner_last_name: zSchema.string(),
  owner_ssn: schemes.ssn(),
  owner_state: zSchema.string(),
  owner_title: zSchema.string(),
  owner_zip: schemes.zipCode(),
  ownership_percentage: zSchema.number().min(0).max(100),
  testMode: zSchema.boolean().default(false),
});

export type ICompanyAddDepositAccountsRequestBody = zSchema.infer<
  typeof CompanyAddDepositAccountsRequestBodySchema
>;

export type ICompanyAddDepositAccountsResponseBody = IApiResponse<ICompanyUser>;
